export default {
  ppmRow1: 'PPM是管理从组合项目、项目集、项目、任务、活动到资源的集成研发项目管理软件。基于最新的技术架构打造，低成本、高性能，PPM能够高效管理整个产品开发过程中所有项目的执行过程，并支持投资决策。',
  ppmRow2: 'PPM支持项目组合层面的投资决策分析以及资源优化，也能够把优化决策落实到具体的日常任务上，并跟踪其执行效果。',
  ppmRow3: '围绕公司战略选择项目组合；',
  ppmRow4: '实时跟踪项目进度、成本和质量；',
  ppmRow5: '监控量化指标，并支持What-if分析，从而做出继续、增加资源和停止某项目的决策；',
  ppmRow6: '管理多项目和项目多层级，提供资源优化算法支持资源排程。'
}
